import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { damagedAPI, productAPI } from '../services/api';
import { Button, Modal, Badge, Spinner, EmptyState, PageHeader, StatCard } from '../components/Common';

const DAMAGE_TYPES = [
  { value: 'damaged', label: '💔 Damaged (Toot Gaya)', color: 'red' },
  { value: 'waste',   label: '🗑 Waste (Kharab Hua)',  color: 'orange' },
  { value: 'lost',    label: '❓ Lost (Kho Gaya)',     color: 'blue' },
];

const REASONS = [
  'Toot Gaya', 'Expire Ho Gaya', 'Geela Ho Gaya',
  'Aag Se Nuksaan', 'Chuha/Keeda', 'Transport Damage',
  'Quality Issue', 'Other'
];

const DamagedPage = () => {
  const [products,   setProducts]   = useState([]);
  const [logs,       setLogs]       = useState([]);
  const [summary,    setSummary]    = useState({});
  const [loading,    setLoading]    = useState(true);
  const [showModal,  setShowModal]  = useState(false);
  const [saving,     setSaving]     = useState(false);
  const [activeTab,  setActiveTab]  = useState('report');
  const [filterType, setFilterType] = useState('');

  const [form, setForm] = useState({
    product_id: '',
    quantity: '',
    type: 'damaged',
    reason: '',
    note: '',
  });

  const load = async () => {
    try {
      const [prodRes, histRes] = await Promise.all([
        productAPI.getAll(),
        damagedAPI.getHistory({ type: filterType }),
      ]);
      setProducts(prodRes.data.products);
      setLogs(histRes.data.logs);
      setSummary(histRes.data.summary);
    } catch { toast.error('Data load nahi hua'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [filterType]);

  const handleReport = async () => {
    if (!form.product_id || !form.quantity || !form.reason) {
      toast.error('Product, Quantity aur Reason required hai'); return;
    }
    setSaving(true);
    try {
      const res = await damagedAPI.report(form);
      toast.success(res.data.message);
      setShowModal(false);
      setForm({ product_id: '', quantity: '', type: 'damaged', reason: '', note: '' });
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya');
    } finally { setSaving(false); }
  };

  const selProduct = products.find(p => String(p.id) === String(form.product_id));

  const typeColor = (type) => {
    if (type === 'damaged') return 'red';
    if (type === 'waste')   return 'orange';
    if (type === 'lost')    return 'blue';
    return 'gray';
  };

  const typeLabel = (type) => {
    if (type === 'damaged') return '💔 Damaged';
    if (type === 'waste')   return '🗑 Waste';
    if (type === 'lost')    return '❓ Lost';
    return type;
  };

  if (loading) return <Spinner />;

  return (
    <div className="page">
      <PageHeader
        title="💔 Damaged Stock Management"
        subtitle="Damaged, Broken & Lost Products Record"
        actions={
          <Button variant="danger" onClick={() => setShowModal(true)}>
            + Damage Report Karo
          </Button>
        }
      />

      {/* Stats */}
      <div className="stats-grid gstr-grid">

        {/* Total Records */}
        <div className="stats-container">
          <div className="stat-card stat-red">
            <div className="icon">💔</div>
            <div className="details">
              <div className="value">
                {summary.total_records || 0}
              </div>
              <div className="label">Total Records</div>
              <div className="sub-text">
                Sab damage records
              </div>
            </div>
          </div>

          {/* Total Loss */}
          <div className="stat-card stat-red">
            <div className="icon">💰</div>
            <div className="details">
              <div className="value">
                ₹{(summary.total_loss || 0).toLocaleString('en-IN')}
              </div>
              <div className="label">Total Loss</div>
              <div className="sub-text">
                Purchase price pe
              </div>
            </div>
          </div>

          {/* Damaged */}
          <div className="stat-card stat-orange">
            <div className="icon">🔨</div>
            <div className="details">
              <div className="value">
                {summary.damaged_count || 0}
              </div>
              <div className="label">Damaged</div>
              <div className="sub-text">
                Toot gaye
              </div>
            </div>
          </div>

          {/* Waste/Lost */}
          <div className="stat-card stat-blue">
            <div className="icon">🗑</div>
            <div className="details">
              <div className="value">
                {(summary.waste_count || 0) + (summary.lost_count || 0)}
              </div>
              <div className="label">Waste/Lost</div>
              <div className="sub-text">
                Kharab/Kho gaye
              </div>
            </div>
          </div>
        </div>

        {/* <StatCard icon="💔" label="Total Records"
          value={summary.total_records || 0}
          sub="Sab damage records"
          color="red" />
        <StatCard icon="💰" label="Total Loss"
          value={'Rs.' + (summary.total_loss || 0).toLocaleString('en-IN')}
          sub="Purchase price pe"
          color="red" />
        <StatCard icon="🔨" label="Damaged"
          value={summary.damaged_count || 0}
          sub="Toot gaye"
          color="orange" />
        <StatCard icon="🗑" label="Waste/Lost"
          value={(summary.waste_count || 0) + (summary.lost_count || 0)}
          sub="Kharab/Kho gaye"
          color="blue" /> */}
      </div>

      {/* Filter */}
      <div className='damage-gstr' style={{ display:'flex', gap:8, marginBottom:20 }}>
        <button
          className={'btn btn-sm ' + (filterType==='' ? 'btn-primary' : 'btn-ghost')}
          onClick={() => setFilterType('')}
        >
          📋 Sab
        </button>
        {DAMAGE_TYPES.map(t => (
          <button
            key={t.value}
            className={'btn btn-sm ' + (filterType===t.value ? 'btn-primary' : 'btn-ghost')}
            onClick={() => setFilterType(t.value)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* History Table */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">📋 Damage History</span>
          <Badge variant="red">{logs.length} records</Badge>
        </div>
        <div className="table-wrap">
          {logs.length === 0 ? (
            <EmptyState icon="✅" title="Koi damage record nahi" message="Abhi tak koi product damaged nahi hua" />
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Product</th><th>Type</th><th>Qty Lost</th>
                  <th>Stock Before</th><th>Stock After</th>
                  <th>Reason</th><th>Loss Amount</th><th>Date</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => {
                  const lossAmt = Math.abs(parseFloat(log.quantity_change)) * parseFloat(log.product?.buy_price || 0);
                  return (
                    <tr key={log.id}>
                      <td><strong>{log.product?.name || '—'}</strong></td>
                      <td><Badge variant={typeColor(log.type)}>{typeLabel(log.type)}</Badge></td>
                      <td style={{ color:'var(--danger)', fontWeight:600 }}>
                        -{Math.abs(parseFloat(log.quantity_change)).toFixed(1)} {log.product?.unit}
                      </td>
                      <td style={{ color:'var(--text2)' }}>{parseFloat(log.quantity_before).toFixed(1)}</td>
                      <td style={{ color:'var(--accent2)' }}>{parseFloat(log.quantity_after).toFixed(1)}</td>
                      <td style={{ fontSize:12, color:'var(--text2)' }}>{log.note || '—'}</td>
                      <td style={{ color:'var(--danger)', fontWeight:600 }}>
                        Rs.{Math.round(lossAmt).toLocaleString('en-IN')}
                      </td>
                      <td style={{ fontSize:12, color:'var(--text3)' }}>
                        {new Date(log.createdAt).toLocaleDateString('en-IN')}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Report Modal */}
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="💔 Submit Damage Report"
        size="md"
      >
        {/* Type Select */}
        <div className="form-group">
          <label className="form-label">Damage Type *</label>
          <div className='modal-damage' style={{ display:'flex', gap:8 }}>
            {DAMAGE_TYPES.map(t => (
              <button
                key={t.value}
                className={'btn btn-sm ' + (form.type===t.value ? 'btn-danger' : 'btn-ghost')}
                onClick={() => setForm({...form, type: t.value})}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {/* Product Select */}
        <div className="form-group">
          <label className="form-label">Product *</label>
          <select
            className="form-input"
            value={form.product_id}
            onChange={e => setForm({...form, product_id: e.target.value})}
          >
            <option value="">-- Please choose a product --</option>
            {products.map(p => (
              <option key={p.id} value={p.id}>
                {p.name} ({p.quantity} {p.unit} available)
              </option>
            ))}
          </select>
        </div>

        {/* Current Stock Info */}
        {selProduct && (
          <div style={{
            background:'var(--bg3)', borderRadius:8, padding:12,
            marginBottom:16, fontSize:13,
          }}>
            <div style={{ display:'flex', gap:20 }}>
              <div>
                <span style={{ color:'var(--text3)' }}>Current Stock: </span>
                <strong style={{ color:'var(--accent2)' }}>{selProduct.quantity} {selProduct.unit}</strong>
              </div>
              <div>
                <span style={{ color:'var(--text3)' }}>Buy Price: </span>
                <strong>Rs.{parseFloat(selProduct.buy_price).toFixed(0)}</strong>
              </div>
            </div>
            {form.quantity && (
              <div style={{ marginTop:8, color:'var(--danger)' }}>
                💰 Estimated Loss: <strong>
                  Rs.{Math.round(parseFloat(form.quantity) * parseFloat(selProduct.buy_price)).toLocaleString('en-IN')}
                </strong>
              </div>
            )}
          </div>
        )}

        {/* Quantity */}
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Quantity *</label>
            <input
              className="form-input"
              type="number"
              step="0.01"
              min="0.01"
              placeholder="Kitna damaged hua"
              value={form.quantity}
              onChange={e => setForm({...form, quantity: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Reason *</label>
            <select
              className="form-input"
              value={form.reason}
              onChange={e => setForm({...form, reason: e.target.value})}
            >
              <option value="">-- Please choose a reason --</option>
              {REASONS.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
        </div>

        {/* Note */}
        <div className="form-group">
          <label className="form-label">Additional Note</label>
          <input
            className="form-input"
            placeholder="Additional Details..."
            value={form.note}
            onChange={e => setForm({...form, note: e.target.value})}
          />
        </div>

        <div className="modal-footer">
          <Button variant="ghost" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleReport} loading={saving}>
            💔 Submit Report
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DamagedPage;